import { render, staticRenderFns } from "./PensionUnitSelectionShow.vue?vue&type=template&id=f6d3e12a&scoped=true&"
import script from "./PensionUnitSelectionShow.vue?vue&type=script&lang=ts&"
export * from "./PensionUnitSelectionShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d3e12a",
  null
  
)

export default component.exports